'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardValidationsCtrl', require('./dashboardValidationsCtrl'));
app.config(['$stateProvider', require('./dashboardValidationsConfig')]);
